import React, { Fragment, useState, useEffect } from 'react'
import { Col, Row } from 'reactstrap'
import { API_URL } from '../../utils/Constants/URLS.js'
import Modal from 'react-bootstrap/Modal'
import { useNavigate, useParams } from 'react-router-dom'

const SearchExistingCompany = () => {
  const { id } = useParams()
  const [showDropdown, setShowDropdown] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showDeclineModal, setShowDeclineModal] = useState(false)
  const [filteredCompanies, setFilteredCompanies] = useState([])
  const [debounceTimeout, setDebounceTimeout] = useState(null)
  const [clientName, setClientName] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  useEffect(() => {
    searchClient()
  }, [])

  const handleCloseModal = () => {
    setShowSuccessModal(false)
    setShowDeclineModal(false)
    navigate('/view_leads')
  }
  const searchClient = async () => {
    const url = `${API_URL}clients?pagination=false`
    const data = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })

    const result = await data.json()
    setClientName(result.data.docs)
  }

  const updateCLientIdForLead = async client_id => {
    try {
      const res = await fetch(`${API_URL}leads/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ client: client_id })
      })
      const response = await res.json()
      if (response.error === false) {
        setModalMessage('Client is successfully assigned to the lead')
        setShowSuccessModal(true)
      } else {
        setModalMessage('Something Went Wrong')
        setShowDeclineModal(true)
      }
    } catch (e) {
      setModalMessage('Oops! Error while assiging client')
      setShowDeclineModal(true)
    }
  }

  const handleSearchChange = e => {
    const value = e.target.value
    setSearchTerm(value)

    // Clear the previous timeout
    if (debounceTimeout) {
      clearTimeout(debounceTimeout)
    }

    // Set a new timeout for the debounce
    const newTimeout = setTimeout(() => {
      const filtered = clientName.filter(company =>
        company.companyName.toLowerCase().includes(value.toLowerCase())
      )
      setFilteredCompanies(filtered)
      setShowDropdown(filtered.length > 0) // Show dropdown only if there are results
    }, 300) // 300ms delay for debouncing

    setDebounceTimeout(newTimeout)
  }
  return (
    <Fragment>
      <Row>
        <Col md={6}>
          <div className='search-box me-2 mb-2 d-inline-block'>
            <label htmlFor='validationCustom04' className='form-label'>
              Client Name <span className='text-danger'>*</span>
            </label>
            <input
              type='text'
              className='form-control mb-2'
              placeholder='Search Client Name'
              value={searchTerm}
              onFocus={() => setShowDropdown(true)}
              onChange={handleSearchChange}
            />
            {showDropdown && (
              <ul
                className='list-group'
                style={{ maxHeight: '200px', overflowY: 'auto' }}
              >
                {filteredCompanies.length > 0 ? (
                  filteredCompanies.map((company, index) => (
                    <li
                      key={index}
                      className='list-group-item list-group-item-action'
                      onClick={() => updateCLientIdForLead(company._id)}
                      style={{ cursor: 'pointer' }}
                    >
                      {company.companyName}
                    </li>
                  ))
                ) : (
                  <li className='list-group-item'>No results found</li>
                )}
              </ul>
            )}
          </div>
        </Col>
        <Modal show={showSuccessModal} centered>
          <Modal.Body>
            <div class='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 shrink-0 fill-green-500 inline'
                viewBox='0 0 512 512'
              >
                <path
                  d='M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z'
                  data-original='#000000'
                />
                <path
                  d='M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z'
                  data-original='#000000'
                />
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>Good Job</h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                {modalMessage}!
              </p>
            </div>

            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-green-500 hover:bg-green-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
        <Modal show={showDeclineModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 fill-red-500 inline'
                viewBox='0 0 286.054 286.054'
              >
                <path
                  fill='#e2574c'
                  d='M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z'
                  data-original='#e2574c'
                ></path>
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>
                Error Occured
              </h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                {modalMessage}!
              </p>
            </div>

            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-red-500 hover:bg-red-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
      </Row>
    </Fragment>
  )
}

export default SearchExistingCompany
